import { render, staticRenderFns } from "./DonationMore.vue?vue&type=template&id=6bbf30cc&"
import script from "./DonationMore.vue?vue&type=script&lang=js&"
export * from "./DonationMore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports